import pluralize from './pluralize'

export default function toYears(val = 0, suffix = 'Month', yearSuffix = 'Year') {
	if (String(val).match(/life/i)) return `Life`
	if (String(val).match(/death/i)) return `Death Penalty`
	if (String(val).match(/any/i)) return `Any term of years`

	if (val > 11) {
		val = Math.round(Number(val) / 12 * 100) / 100
		return pluralize(val, yearSuffix)
	} else if (val < 1 && val != 0) {
		val = Math.round(Number(val) * 30)
		return pluralize(val, 'Day')
	}

	return pluralize(Number(val), suffix)

}
